import { render, staticRenderFns } from "./ChatiView.vue?vue&type=template&id=35506674"
import script from "./ChatiView.vue?vue&type=script&lang=js"
export * from "./ChatiView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports